import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip, Col } from "antd";
import axios from "axios";
import "./Pages.css";
import CondPagtoForm from '../components/CondPagtoForm';
import CondPagtosPrintModal from "../relatorios/CondPagtosPrintModal";
import { getTemPermissao, getTipoUsuario } from "../utils/LoginManager";
import numeral from "numeral";
import Colors from '../utils/Colors';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
  };

  componentDidMount() {
    getTipoUsuario().then(tipoUsuario => {
      this.setState({
        tipoUsuario,
      },
        this.getListaRegistros()
      );
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, });
    const { busca, pagina, limite } = this.state;
    axios
      .get('/condPagto', {
        params: {
          page: pagina,
          limite: limite,
          buscaDescricao: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.cp_idf) {
      request = axios.put(`/condPagto/update/${registro.cp_idf}`, registro);
    } else {
      request = axios.post(`/condPagto/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Registro gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/condPagto/show/${registro.cp_idf}`)
      .then(response => {
        const { data } = response;

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/condPagto/delete/${registro.cp_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.cp_idf === registro.cp_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {}
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/condPagto/ativa/${registro.cp_idf}/1`)
    } else {
      request = axios.put(`/condPagto/ativa/${registro.cp_idf}/0`)
    }

    request.then(response => {
      registro.cp_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };

  renderAtiva = (cp_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={cp_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        disabled={getTemPermissao('CondPagtosPage', 'editar') ? false : true}
        style={{ backgroundColor: !cp_situacao ? null : Colors.primary }}
      />
    );
  };

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };



  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar" placement="left">
          <Button className="botoesModalFormEditar" disabled={getTemPermissao('CondPagtosPage', 'editar') ? false : true} size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir" placement="right">
          <Button className="botoesModalFormExcluir" disabled={getTemPermissao('CondPagtosPage', 'excluir') ? false : true} size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite, busca } = this.state;

    // console.log('CondPagtosPage: ',  this.state)

    return (
      <div className="contentRoutesContainer">
        <div>
          <h2 className="tituloPage">Cadastro de Condições de Pagamentos</h2>
          <hr />
          <br />

          <div className="pageFiltro" style={{ marginBottom: 30 }}>
            {(!this.state.tipoUsuario) || (getTemPermissao('CondPagtosPage', 'novo')) ? (
              <Col xs={2} style={{ width: 110 }}>
                <Button
                  onClick={this.onAdicionarClick}
                  className="pageFiltro-adicionar"
                >
                  Adicionar
                </Button>
              </Col>
            ) : null}

            <Col xs={8} style={{}}>
              <Search
                placeholder="Buscar por Descrição"
                onSearch={this.onBuscar}
                enterButton
                className="pageFiltro-busca"
              />
            </Col>

            <Col xs={2} style={{ width: 110 }}>
              <CondPagtosPrintModal
                buscaDescricao={busca}
              />
            </Col>

            <CondPagtoForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

          </div>

          <br />

          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.cp_idf)}
          >
            <Column
              key="cp_codigo"
              dataIndex="cp_codigo"
              title="Código"
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="cp_descricao"
              dataIndex="cp_descricao"
              title="Descrição"
              width={"30%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="cp_parcelas"
              dataIndex="cp_parcelas"
              title="Parcelas"
              width={"20%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="cp_vlr_ped_ini"
              dataIndex="cp_vlr_ped_ini"
              title="Vlr Inicial Pedido"
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="cp_vlr_ped_fim"
              dataIndex="cp_vlr_ped_fim"
              title="Vlr Final Pedido"
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="cp_situacao"
              dataIndex="cp_situacao"
              title="Situação"
              render={this.renderAtiva}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />

            {getTemPermissao('CondPagtosPage', 'editar') || getTemPermissao('CondPagtosPage', 'excluir') ? (
              <Column
                key="acoes"
                title="Ações"
                render={this.renderAcoes}
                width={"20%"}
                align="center"
                className="listaCadastro"
              />
            ) : null}
          </Table>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CondPagtosPage.js